import { SET_ONSTREET_LOCATIONS } from 'on-street/constants'

export const onStreet = (state = [], action) => (action.type === SET_ONSTREET_LOCATIONS ? action.locations : state)
